export default {
  button: {
    preview: 'Preview',
    save_n_publish: 'Save & Publish',
    back_to_edit: 'Continue Editing',
    edit: 'Edit Video',
    discard: 'Discard',
    copy_link: 'Copy Link',
    embed_video: 'Embed Video',
    update_settings: 'Update Video',
    delete: 'Delete Video',
    edit_collection: 'Edit Collection',
    edit_title: 'Edit Video Title',
    update_title: 'Update',
    update_description: 'Update Description',
    add_video_description: 'Add video description',
    flow: 'Use as learning path',
    private_video: 'Make video private'
  },
  link: {
    go_to_edit: 'Edit video steps',
    back_to_videos: 'Back to all videos',
    back_to_video: 'Back to video',
    back_to_collections: 'Back to all learning paths',
    back_to_collection: 'Back to learning path',
    back_to_player: 'Back',
    back: 'Back',
    add_thumbnail: 'Add thumbnail image'
  },
  loading: {
    preview: 'Loading your preview...',
    video: 'Loading your video...'
  },
  thumbnail_settings: {
    label: `{type} Thumbnail Image`,
    description:
      "Uploaded image will be used as this {type}'s thumbnail image in your portal hub",
    update: 'Update'
  },
  publishing: {
    text:
      'Your video is getting published. This might take a minimum of few seconds to a maximum of few minutes.',
    link: 'Explore the app in meanwhile',
    success: 'Your video has been published successfully',
    info: 'This video has some active changes that are getting published'
  },
  preview: {
    info:
      'This is just a preview. Call-To-Actions, Chapters & Subtitles if any will be displayed in the final published video.'
  },
  learning_flow: 'Trainn your customers on a workflow with videos',
  settings: 'Player Settings',
  voice_selection: 'I will go with',
  voice_final: 'Your narration voice',
  bg_selection: 'Background score',
  watermark: 'Watermark settings',
  watermark_label: 'Add logo watermark',
  view_analytics: 'View Analytics',
  subtitles: {
    title: 'Subtitles / Closed captions (CC)',
    description: 'Select languages',
    languages: {
      english: 'English',
      spanish: 'Spanish',
      portuguese: 'Portuguese',
      french: 'French',
      hindi: 'Hindi'
    },
    addTag: 'Add a language',
    translate: 'Translate text into %{lang}',
    settings: {
      title: 'Subtitles and closed captions (CC)'
    }
  },
  references: 'References',
  title: {
    label: 'Video name',
    placeholder: 'How to create a ticket in Jira'
  },
  description: {
    label: 'Video description'
  },
  quick_jump: {
    title: 'Quick Jump Settings',
    description: 'Allow your audience to easily navigate within the video.',
    options: {
      disabled: {
        label: 'Hide quick jumps',
        description: 'Quick jumping spots will disappear from the slider'
      },
      steps: 'Show block level quick jumps',
      chapters: {
        label: 'Show chapter level quick jumps',
        description: 'Useful for longer videos that have informative content.'
      }
    }
  },
  permission_settings: {
    title: 'Share Video',
    learning_path_title: 'Share Learning Path',
    disable_description:
      'Embedding this video in other applications and sharing video via links is disabled.',
    disable_learning_path_description:
      'Sharing learning paths via links is disabled.',
    link: {
      title: 'Share via link',
      label: 'Private link',
      description:
        'Anyone with the link can view the content, but will not appear in Google search.'
    },
    gif: {
      title: 'Share via Gif',
      description: 'Embed thumbnail gif within your emails.'
    },
    set_password: 'Set Password',
    embed: {
      title: 'Embed via code',
      description:
        "By embedding Trainn videos on your site, you are agreeing to Trainn's Terms and Conditions and Privacy Policy",
      modal_title: 'Embed code'
    }
  },
  header: {
    active: 'You are in edit mode!',
    active_link: 'View live version',
    publishing: 'Your changes are getting published',
    on_boarded: 'Publish your changes to go live'
  },
  download_images: {
    title: 'Download Images',
    description: 'Download images for using it in your step by step tutorials.',
    cta: 'Download'
  },
  download_pdf: {
    title: 'Download Pdf',
    description:
      'Download the generated pdf with the corresponding highlighting and voiceovers.',
    cta: 'Download'
  },
  analytics: {
    title: 'Video stats',
    satisfaction: 'Satisfactory Count',
    description: 'The data shown are the metrics for the past 30 days',
    btn: 'View stats',
    modal: {
      description:
        'The data shown below are the metrics taken for the past 30 days',
      totalViews: 'Total views:',
      uniqueViews: 'Unique views for today:',
      placeholder:
        'You will see the stats here once viewers have started seeing this video. Go ahead and share this video.'
    }
  },
  videos: {
    delete: {
      link: 'Click to delete this video',
      title: 'Are you sure you want to delete this video?',
      description:
        'On deleting, this video will be deleted forever. Any links associated with this video will not be available anymore.',
      delete_btn: 'Yes, Delete it!',
      delete_cta: 'Delete Video',
      cancel: "No, don't delete it"
    },
    clone: {
      title: 'Clone the Video?',
      description:
        'An exact copy of the video will be created. The cloned video will be initially in draft state. You can modify the video if needed and publish it.',
      clone_with_copy: 'Include narration',
      clone_btn: 'Clone Video',
      clone_voice_label: 'New narration voice',
      cancel: 'Cancel'
    },
    download_video: {
      title: 'Download Video',
      description:
        'An mp4 version of your video will be downloaded. Your download will take a minimum of few seconds to a maximum of few minutes. We will also email you once your video has been downloaded.',
      cancel: 'Cancel',
      btn: 'Download Video',
      downloading: 'Downloading Video...'
    },
    dt: {
      title: 'Download Transcript',
      description: 'Your transcript file will be downloaded as CSV',
      dt_btn: 'Download Transcript',
      cancel: 'Cancel'
    },
    privacy: {
      title: 'Change video privacy',
      private: 'Private Access',
      private_desc:
        'The videos cannot be shared via links. Only the members who has access will be able to view it in the academy.',
      public: 'Public Access',
      public_desc:
        'Anyone with the link of the video will be able to view the video content.',
      privacy_btn: 'Change video privacy',
      cancel: 'Cancel'
    },
    youtube: {
      title: 'Publish To YouTube',
      cta: 'Publish To YouTube',
      description:
        "Publish the latest version to your '%{channel_name}' youtube channel. Once the video is published, it will be publicly available to all users.",
      cancel: 'Cancel',
      history_title: 'YouTube - Publish Logs',
      channel: 'Channel',
      video_version: 'Version',
      empty: 'No versions were published to YouTube',
      exists:
        'Current version is either getting published or already been published!'
    },
    deleted: 'This video is no longer available',
    link_deleted: 'This link is no longer valid',
    share_text: 'Like & Follow us on'
  }
};
